export default "/_next/static/images/cfdc3ae4e24c2f23c80355d3beb6a3d1.png";